import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Autosuggest from "react-autosuggest";
import {
	updateCityItem,
	updateCityValue,
	loadCitiesSuggestions,
	clearCitiesSuggestions,
} from "features/account/citiesSlice";

export default function CityAutosuggest(props) {
	const dispatch = useDispatch();
	// Selectors
	const { value, suggestions } = useSelector((state) => state.cities);
	// Handlers
	function handleChange(event, { newValue }) {
		dispatch(updateCityValue({ value: newValue }));
	}
	function onSuggestionSelected(event, { suggestion }) {
		dispatch(updateCityItem({ selectedItem: suggestion }));
	}
	function onSuggestionsFetchRequested({ value }) {
		dispatch(loadCitiesSuggestions(value));
	}
	function onSuggestionsClearRequested() {
		dispatch(clearCitiesSuggestions());
	}
	function getSuggestionValue(suggestion) {
		return suggestion.Cd;
	}
	function shouldRenderSuggestions() {
		return true;
	}
	function renderSuggestion(suggestion) {
		return <div>{suggestion.Cd}</div>;
	}
	// Render
	const inputProps = {
		placeholder: "Ciudad",
		value,
		onChange: handleChange,
		autoComplete: "erp-city-from-database",
		onSelect: props.onSelect,
	};
	return (
		<div className="field">
			<Autosuggest
				suggestions={suggestions}
				onSuggestionsFetchRequested={onSuggestionsFetchRequested}
				onSuggestionsClearRequested={onSuggestionsClearRequested}
				getSuggestionValue={getSuggestionValue}
				shouldRenderSuggestions={shouldRenderSuggestions}
				renderSuggestion={renderSuggestion}
				onSuggestionSelected={onSuggestionSelected}
				inputProps={inputProps}
				id="city"
			/>
		</div>
	);
}
